// @ts-strict-ignore
import { context, Dictionary, pbjsFactory, slotService } from '@ad-engine/core';
import { isUsedAsAlias } from '../bidder-helper';
import { intentIQ } from './intent-iq';
import { PrebidAdapterConfig } from './prebid-models';

const videoType = 'video';

export const validResponseStatusCode = 1;

export function isSlotApplicable(code): boolean {
	// This can be simplified once we get rid of uppercase slot names
	const isApplicable = context.get(`slots.${code}`)
		? slotService.getState(code)
		: isUsedAsAlias(code);

	if (!(context.get('bidders.prebid.filter') === 'static') || code.includes('video')) {
		return isApplicable;
	}

	return document.querySelector(`div[id="${code}"]`) !== null ? isApplicable : false;
}

export async function getBidUUID(adUnitCode: string, adId: string): Promise<string> {
	const bid = await getBidByAdId(adUnitCode, adId);

	if (bid && bid.mediaType === videoType) {
		return bid.videoCacheKey;
	}

	return 'disabled';
}

export async function getBidByAdId(adUnitCode, adId): Promise<PrebidBidResponse> {
	const pbjs: Pbjs = await pbjsFactory.init();
	const { bids } = pbjs.getBidResponsesForAdUnitCode(adUnitCode);
	const foundBids = bids.filter((bid) => adId === bid.adId);

	return foundBids.length ? foundBids[0] : null;
}

export function getDealsTargetingFromBid(bid: Dictionary): PrebidTargeting {
	const keyValuePairs: Dictionary = {};

	Object.keys(bid.adserverTargeting).forEach((key) => {
		if (key.indexOf('hb_deal_') === 0) {
			keyValuePairs[key] = bid.adserverTargeting[key];
		}
	});

	return keyValuePairs;
}

export function isPrebidAdapterConfig(
	config: PrebidAdapterConfig | any,
): config is PrebidAdapterConfig {
	if (!(typeof config === 'object')) {
		return false;
	}

	const hasEnabledField = typeof config.enabled === 'boolean';
	const hasSlotsDictionary = typeof config.slots === 'object';

	return hasEnabledField && hasSlotsDictionary;
}

export async function requestBids(
	adUnits: PrebidAdUnit[],
	bidsBackHandler: (...args: any[]) => void,
	timeout: number,
): Promise<void> {
	const pbjs: Pbjs = await pbjsFactory.init();

	await intentIQ.initialize(pbjs);

	pbjs.requestBids({
		adUnits,
		bidsBackHandler,
		timeout,
	});
}
